<div class="main">
  <div class="leftside">
    <img src="assets/LeftSideTriangles.svg" alt="">
  </div>
  <div class="rightside">
    <img src="assets/RightSideTriangles.svg" alt="">
  </div>

  <div class="section">
    <div class="center">
      <div class="logo">
        <img src="assets/SmartTruck-Logo-HalfWhite.svg" alt="">
      </div>
      <div class="card">
        <div class="background">
          <div class="barLine"></div>
          <img src="assets/User-Circle.svg" class="userIcon" alt="">
        </div>
        <div class="forgot">
          {{component}}
        </div>
        <div class="form">
          <input type="password"  placeholder="New Password" class="formField" autocomplete="false" [(ngModel)]="newData.password" (keyup)="passwordStrengthChecker()">

          <div class="passwordStrength" >
            <password-strength-meter  [password]="newData.password"></password-strength-meter>
          </div>

          <ul class="passwordWarnings" *ngIf="!passwordStrengthPassedCheck.overall">
            <li [hidden]="passwordStrengthPassedCheck.minimumChars">Minimum 8 characters</li>
            <li [hidden]="passwordStrengthPassedCheck.oneSpecial">One Special Character</li>
            <li [hidden]="passwordStrengthPassedCheck.oneNumeric">One Number</li>
            <li [hidden]="passwordStrengthPassedCheck.oneCapital">One Capital Character</li>
          </ul>

          <input type="password" [hidden]="!passwordStrengthPassedCheck.overall"  placeholder="Confirm Password" class="formField" autocomplete="false" [(ngModel)]="newData.confirmPassword">

          <div class="buttons">
            <div class="submitButton" [hidden]="!passwordStrengthPassedCheck.overall" [routerLink]="['/login']" style="background-color: #747474;">
              Back
            </div>
            <div class="submitButton" [hidden]="!passwordStrengthPassedCheck.overall" (click)="submit();" [routerLink]="flag ? ['/login'] : []">
              Submit
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
